import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerStmtExpService } from '../owner-stmt-exp.service';
import { OwnerStmtExp } from '../owner-stmt-exp';
import { OwnerStmtExpComponent } from '../owner-stmt-exp/owner-stmt-exp.component';
import { PropertyService } from '@app/_components/property';
import { OwnerStmtService } from '@app/_components/owner-stmt/owner-stmt.service';
import * as moment from 'moment';

@Component({
    selector: 'app-owner-stmt-exp-list',
    templateUrl: './owner-stmt-exp-list.component.html',
    styleUrls: ['./owner-stmt-exp-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerStmtExpListComponent implements OnInit {
	properties: any;
	expenseDateRange: Date[] = [];
	stmtBilledDateRange: Date[] = [];

	constructor(
		private ownerStmtExpService: OwnerStmtExpService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private propertyService: PropertyService,
		public ownerStmtService: OwnerStmtService
	) {
		this.statuses = ownerStmtExpService.statuses;
	}

	// data
	@Input() ownerStmtId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	
	ownerStmtExps: any;
	ownerStmtExp: OwnerStmtExp;
	shortTermRentalId: any[] = [];

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ownerStmtExpId', header: 'Id', width: 'auto', showSort: true },
		{ field: 'ownerStmtVO.shortTermRentalId', header: 'Property Code', width: 'auto', showSort: true },
		{ field: 'name', header: 'Task', width: 'auto', showSort: true },
		{ field: 'expenseDate', header: 'Expense Date', width: 'auto', showSort: true },
		{ field: 'stmtBilledDate', header: 'Stmt Billed Date', width: 'auto', showSort: true },
		{ field: 'expenseCategory', header: 'Category', width: 'auto', showSort: true },
		{ field: 'expenseAmount', header: 'Total', width: 'auto', showSort: false },
		{ field: 'paidByKbm', header: 'KBM Paid', width: 'auto', showSort: false },
		{ field: 'paidByOwner', header: 'Owner Paid', width: 'auto', showSort: false },
		{ field: 'materialsPaidByKbm', header: 'Materials (KBM)', width: 'auto', showSort: false },
		{ field: 'materialsPaidByOwner', header: 'Materials (Owner)', width: 'auto', showSort: false },
		{ field: 'laborPaidByKbm', header: 'Labor (KBM)', width: 'auto', showSort: false },
		{ field: 'laborPadiByOwner', header: 'Labor (Owner)', width: 'auto', showSort: false },
		{ field: 'thirdPartExpensePaidByKbm', header: 'Third-Party (KBM)', width: 'auto', showSort: false },
		{ field: 'thirdPartExpensePaidByOwner', header: 'Third-Party (Owner)', width: 'auto', showSort: false },
		{ field: 'taxPaidByKbm', header: 'Tax (KBM)', width: 'auto', showSort: false },
		{ field: 'taxPadiByOwner', header: 'Tax (Owner)', width: 'auto', showSort: false },
		{ field: 'miscPaidByKbm', header: 'Misc (KBM)', width: 'auto', showSort: false },
		{ field: 'miscPaidByOwner', header: 'Misc (Owner)', width: 'auto', showSort: false },
		{ field: 'startDate', header: 'Start Date', width: 'auto', showSort: true },
		{ field: 'endDate', header: 'End Date', width: 'auto', showSort: true },
	];

	ngOnInit(): void {
		console.log('ownerStmtId ownerStmtId ownerStmtId: ' + this.ownerStmtId);
		this.fetchProperties();

		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'expenseDate', order: -1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.propertySummaryIndividualPropertyList()
					.subscribe(
						res => {
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			return (this.properties);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerStmtExpId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			// Ensure filters object exists
			event.filters = event.filters || {};

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerStmtExp-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'expenseDate', order: -1 });
			}
			
			if(this.ownerStmtId)
			{
				// show only ownerStmtExps that are assigned to this ownerStmtId
				let ownerStmtIdFilter = { 'ownerStmtId': { 'value': this.ownerStmtId, 'matchMode': 'in' } };
				Object.assign(event.filters, ownerStmtIdFilter);
			}

			// Format date filters if they exist
			if (event.filters?.expenseDateStart) {
				event.filters.expenseDateStart.value = moment(event.filters.expenseDateStart.value).format('yyyy-MM-DD');
			}
			if (event.filters?.expenseDateEnd) {
				event.filters.expenseDateEnd.value = moment(event.filters.expenseDateEnd.value).format('yyyy-MM-DD');
			}
			if (event.filters?.stmtBilledDateStart) {
				event.filters.stmtBilledDateStart.value = moment(event.filters.stmtBilledDateStart.value).format('yyyy-MM-DD');
			}
			if (event.filters?.stmtBilledDateEnd) {
				event.filters.stmtBilledDateEnd.value = moment(event.filters.stmtBilledDateEnd.value).format('yyyy-MM-DD');
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerStmtExpService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerStmtExps = res.data.ownerStmtExps;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerStmtExps = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
			this.loading = false;
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerStmtExp: OwnerStmtExp) {
		try {
			this.formLoading = true;
			this.ownerStmtExpService.update(ownerStmtExp)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtExps.map((ownerStmtExp, i) => {
							if (ownerStmtExp.ownerStmtExpId === res.data.ownerStmtExp.ownerStmtExpId) {
								this.ownerStmtExps[i] = res.data.ownerStmtExp;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerStmtExp: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerStmtExp));

			this.formLoading = true;
			this.ownerStmtExpService.delete(ownerStmtExp.ownerStmtExpId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtExps.splice(this.ownerStmtExps.indexOf(ownerStmtExp), 1);
						this.recordTotal = this.ownerStmtExps.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerStmtExp ' + ownerStmtExp.ownerStmtExpId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerStmtExp ' + ownerStmtExp.ownerStmtExpId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerStmtExp',
			ownerStmtId: this.ownerStmtId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtExpComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOwnerStmtExpCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerStmtExp: OwnerStmtExp) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerStmtExp: ownerStmtExp,
			title: 'Edit OwnerStmtExp'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtExpComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOwnerStmtExpCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerStmtExpCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerStmtExpCB(ownerStmtExp: OwnerStmtExp) {
		console.log('Adding OwnerStmtExp: ' + JSON.stringify(ownerStmtExp));
		// if we don't have a ownerStmtExps array yet...
		if (!this.ownerStmtExps) {
			this.ownerStmtExps = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerStmtExps.unshift(ownerStmtExp);

		// no idea what this is but it is required to update the array
		this.ownerStmtExps = [...this.ownerStmtExps];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtExp ' + ownerStmtExp.ownerStmtExpId + ' Added', life: 3000 });
	}

	updateOwnerStmtExpCB(ownerStmtExp: OwnerStmtExp) {
		console.log('Updating OwnerStmtExp: ' + JSON.stringify(ownerStmtExp));
		let itemIndex = this.ownerStmtExps.findIndex((item: any) => item.ownerStmtExpId === ownerStmtExp.ownerStmtExpId);
		this.ownerStmtExps[itemIndex] = ownerStmtExp;

		// no idea what this is but it is required to update the array
		this.ownerStmtExps = [...this.ownerStmtExps];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtExp ' + ownerStmtExp.ownerStmtExpId + ' Updated', life: 3000 });
	}

	deleteOwnerStmtExpCB(ownerStmtExp: OwnerStmtExp) {
		console.log('Removing OwnerStmtExp: ' + ownerStmtExp);
		this.ownerStmtExps.splice(this.ownerStmtExps.indexOf(ownerStmtExp), 1);
		this.recordTotal = this.ownerStmtExps.length;

		// no idea what this is but it is required to update the array
		this.ownerStmtExps = [...this.ownerStmtExps];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtExp ' + ownerStmtExp.ownerStmtExpId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerStmtExps ? this.first === (this.ownerStmtExps.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerStmtExps ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerStmtExp: any) {
		if (ownerStmtExp?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerStmtExp.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	getPropertyCode(shortTermRentalId: any) {
		if (shortTermRentalId) {
			const property = this.properties?.find((e: any) => e.shortTermRentalId == shortTermRentalId);
			return property?.propertyCode || '';
		}
		else {
			return '';
		}
	}

	getExpenseCategory(ownerStmtExp: any) {
		if (ownerStmtExp?.expenseCategory) {
			const category = this.ownerStmtService.expenseCategories.find((e: any) => e.value == ownerStmtExp.expenseCategory);
			return category?.name || 'TBD';
		}
		return 'TBD';
	}

	toLocal(date: Date | string | null): Date | null {
		if (!date) return null;
		return moment(date).toDate();
	}

	onExpenseDateRangeChange(): void {
		if (!this.lazyLoadEvent) {
			this.lazyLoadEvent = {} as LazyLoadEvent;
		}
		this.lazyLoadEvent.filters = this.lazyLoadEvent.filters || {};

		if (this.expenseDateRange && this.expenseDateRange.length === 2) {
			const startDate = moment(this.expenseDateRange[0]).format('yyyy-MM-DD');
			const endDate = moment(this.expenseDateRange[1]).format('yyyy-MM-DD');
			this.lazyLoadEvent.filters['expenseDateStart'] = {
				value: startDate,
				matchMode: 'gte'
			};
			this.lazyLoadEvent.filters['expenseDateEnd'] = {
				value: endDate,
				matchMode: 'lte'
			};
		} else {
			delete this.lazyLoadEvent.filters['expenseDateStart'];
			delete this.lazyLoadEvent.filters['expenseDateEnd'];
		}

		if (this.lazyLoadEvent) {
			this.loadLazy(this.lazyLoadEvent);
		}
	}

	onStmtBilledDateRangeChange(): void {
		if (!this.lazyLoadEvent) {
			this.lazyLoadEvent = {} as LazyLoadEvent;
		}
		this.lazyLoadEvent.filters = this.lazyLoadEvent.filters || {};

		if (this.stmtBilledDateRange && this.stmtBilledDateRange.length === 2) {
			const startDate = moment(this.stmtBilledDateRange[0]).format('yyyy-MM-DD');
			const endDate = moment(this.stmtBilledDateRange[1]).format('yyyy-MM-DD');
			this.lazyLoadEvent.filters['stmtBilledDateStart'] = {
				value: startDate,
				matchMode: 'gte'
			};
			this.lazyLoadEvent.filters['stmtBilledDateEnd'] = {
				value: endDate,
				matchMode: 'lte'
			};
		} else {
			delete this.lazyLoadEvent.filters['stmtBilledDateStart'];
			delete this.lazyLoadEvent.filters['stmtBilledDateEnd'];
		}

		if (this.lazyLoadEvent) {
			this.loadLazy(this.lazyLoadEvent);
		}
	}
}
